import { api, assetUrl } from './api.config'

export interface IAssetExtensions {
    innerCode: string
    name: string
    description: string
    dependentExtensions: IAssetExtensions[]
    requiredInfos: IRequiredInfos[]
    requiredExtensionsInnerCode: string[]
}

export interface IRequiredInfos {
    innerCode: string
    presenterCode: string
}

export const getAssetExtensions = async (): Promise<IAssetExtensions[]> => {
    return fetch(`${assetUrl}${api.assetExtensions.assetExtensions}/`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(fetchData => {
            if (fetchData.ok) {
                return fetchData.json()
            } else {
                throw new Error(`{"status": ${fetchData.status} , "message": "${fetchData.statusText}"}`)
            }
        })
        .catch(err => {
            return JSON.parse(err.message)
        })
}
export const getAssetExtensionsAsMap = async (): Promise<Map<string, IAssetExtensions>> => {
    return getAssetExtensions().then(objs =>
        objs.reduce((map, obj) => map.set(obj.innerCode, obj), new Map<string, IAssetExtensions>())
    )
}
